<template>
  <div>
    <li @click="notification_open()" class="onhover-dropdown">
      <div class="">
        <svg aria-label="Download" role="img">
          <title>Download</title>
          <use href="@/assets/svg/icon-sprite.svg#download"></use>
        </svg>
      </div>
    </li>
    <financePdf ref="pdf" :datas="datas" />
  </div>
</template>

<script>
import financePdf from "@/pages/master-pdf/master-pdf.vue";
export default {
  components: {
    financePdf,
  },
  name: "Notifications",
  data() {
    return {
      datas: "",
      notification: false,
    };
  },
  methods: {
    notification_open() {
      const path = window.location.pathname;
      if (path === "/") {
        this.datas = "contract";
        // this.$refs.pdf.generateReport();
        this.$store.dispatch("triggerFunction1");
      } else if (path === "/finance") {
        this.datas = "finance";
        // this.$refs.pdf.generateReport();
        this.$store.dispatch("triggerFunction3");
      } else if (path === "/legal-human-capital") {
        this.datas = "legal";
        this.$store.dispatch("triggerFunction4");
        // this.$refs.pdf.generateReport();
      } else if (path === "/generation") {
        this.datas = "generation";
        // this.$refs.pdf.generateReport();
        this.$store.dispatch("triggerFunction5");
      } else if (path === "/distribution") {
        this.datas = "distribution";
        this.$store.dispatch("triggerFunction");
        // this.$store.commit("triggerPage", 'distribution');
        // this.$refs.pdf.generateReport();
      } else if (path === "/data-moonshot") {
        this.datas = "moonshot";
        // this.$refs.pdf.generateReport();
        this.$store.dispatch("triggerFunction6");
      } else if (path === "/summary") {
        this.$store.dispatch("triggerFunction2");
      } else if (path === "/detail-profit") {
        this.$store.dispatch("triggerFunction7");
      } else if (path === "/detail-cash") {
        this.$store.dispatch("triggerFunction8");
      } else if (path === "/detail-assets") {
        this.$store.dispatch("triggerFunction9");
      } else if (path === "/retail-commerce") {
        this.$store.dispatch("triggerFunction10");
      } 

    },
  },
};
</script>
